import { gql } from "@apollo/client";

export const JUSTIFICAR_MINUTA_MASIVA = gql`
  mutation JustificarMinutaMasiva ($input: JustificacionMasivaInput!
  ){
    justificarMinutaMasiva(input: $input) {
      success,
      valorEsperado,
      error
    }
}
`;